module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"submit":"Bestätigen","cancel":"Abbrechen"},"en":{"submit":"Submit","cancel":"Cancel"}}')
  delete Component.options._Ctor
}
